import React from 'react';
import DocumentDefaultsForm from '@/components/cost-center/document-defaults/DocumentDefaultsForm';
import PageLayout from '@/components/layout/PageLayout';
import PageHeader from '@/components/layout/PageHeader';

const DocumentDefaultsPage = () => {
  return (
    <PageLayout>
      <PageHeader
        title="Document Defaults"
        description="Configure default values for documents like estimates and invoices. These settings will be automatically applied when creating new documents."
      />
      <DocumentDefaultsForm />
    </PageLayout>
  );
};

export default DocumentDefaultsPage;
